import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  InputGroup,
  InputGroupAddon,
  CardBody,
  Button,
  FormGroup,
  Table,
  Input
} from "reactstrap";
import { reduxForm, Field } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import Moment from 'react-moment';
import Pagination from 'react-js-pagination';
import printJS from 'print-js';
import Collapsible from 'react-collapsible';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { currentDate } from '../../lib/common'
import * as lsnhapkhoConstant from './constants'
import * as lsnhapkhoAction from './actions'
import { storedb } from '../client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { BtnPermissions } from '../../lib/BtnPermissions';
import { ButtonExt } from "../controls/ButtonExt"

class LsNhapKho extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    lsnhapkhoListRequest: PropTypes.func,
    lsnhapkhoPrintRequest: PropTypes.func,
    lsnhapkhoListNhaCCRequest: PropTypes.func,
    lsnhapkhoListKhoRequest: PropTypes.func,
    lsnhapkhoExportXlsRequest: PropTypes.func,
    lsnhapkho: PropTypes.shape({
      listNcc: PropTypes.array,
      listKho: PropTypes.array,
      list: PropTypes.array,
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }

  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      store_id: dbContext.getStoreId(),
      keyword: '',
      maNhanVien: '',
      startDate: currentDate().startOf('month'),
      endDate: currentDate(),
      item: {},
      list: [],
      listNcc: [],
      listKho: [],
      page: 1,
      per_page: 20,
      selectedOptionNcc: null,
      selectedOptionKho: null,
      NhaCC: "",
      kho: null,
      trangThai: "",
      total_record: 0,
      total_amountBefore: 0,
      total_amountAfter: 0,
      listBarcodePrint: []
    };
  }

  handleNccChange = selectedOptionNcc => {
    this.setState({ selectedOptionNcc });
    this.setState({ NhaCC: selectedOptionNcc.value }, () => {
      //todo this.featchDetail();
    });
  };
  handleKhoChange = selectedOptionKho => {
    this.setState({ selectedOptionKho });
    this.setState({ kho: selectedOptionKho.value }, () => {
      //todo this.featchDetail();
    });
  };
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }
  handleControlChange(name, e, value) {
    switch (name) {
      case "maHoaDon":
        this.setState({ maHoaDon: e.target.value });
        break;
      case "tenThuoc":
        this.setState({ tenThuoc: e.target.value });
        break;
      case "soLo":
        this.setState({ soLo: e.target.value });
        break;
      case "startDate":
        this.setState({ startDate: e });
        break;
      case "endDate":
        this.setState({ endDate: e });
        break;
    }
  }
  handleSelectChange = (name, selectedOption) => {
    switch (name) {
      case "TrangThai":
        this.setState({ trangThai: selectedOption.target.value })
        break;
      default:
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      default:
        break;
    }
  }
  addNhapClick = () => {
    this.props.history.push("/nhap-kho");
  }
  editItem = (item, e) => {
    e.preventDefault();
    this.props.history.push('/nhap-kho-edit-ct?nhapct=' + item.nhapct);
  }
  editSoHd = (soHd, e) => {
    e.preventDefault();
    console.log("soHd", soHd)
    this.props.history.push('/nhap-kho-edit?nhap=' + soHd);
  }
  fetchList(page) {
    const { lsnhapkhoListRequest } = this.props
    const requestData =
    {
      store: this.state.store_id,
      khoId: this.state.kho,
      NhaCC: this.state.NhaCC,
      keyword: this.state.keyword,
      trangThai: this.state.trangThai,
      startDate: this.state.startDate.format('YYYYMMDD'),
      endDate: this.state.endDate.format('YYYYMMDD'),
      page: page || this.state.page,
      per_page: this.state.per_page
    }
    return lsnhapkhoListRequest(requestData)
  }
  search = () => {
    if (this.props.lsnhapkho.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => this.fetchList(1));
  }
  keyPress = (e) => {
    if (e.keyCode == 13) {
      this.search()
    }
  }
  fetchListNhaCC = () => {
    const { lsnhapkhoListNhaCCRequest } = this.props

    var requestData = {
      stores_id: this.state.store_id,
      page: 1,
      per_page: 200
    };
    return lsnhapkhoListNhaCCRequest(requestData);
  }
  buildSelectOptionNcc(listNcc) {
    var options = [];
    if (listNcc && listNcc.length > 0) {
      listNcc.map((item) => { options.push({ value: item.NhaCCId, label: item.Ten }) }
      );
    }
    return options;
  }

  fetchListKho = () => {
    const { lsnhapkhoListKhoRequest } = this.props
    var requestData = {
      StoreId: this.state.store_id,
      keyword: null,
      status: 1,
      cap: 1,
      page: 1,
      per_page: 200
    };
    return lsnhapkhoListKhoRequest(requestData);
  }
  buildSelectOptionKho(listKho) {
    var options = [];
    if (listKho && listKho.length > 0) {
      listKho.map((item) => { options.push({ value: item.KhoId, label: item.Ten }) }
      );
    }
    return options;
  }
  exportXls = () => {
    const { lsnhapkhoExportXlsRequest } = this.props
    const requestData =
    {
      store: this.state.store_id,
      khoId: this.state.kho,
      NhaCC: this.state.NhaCC,
      keyword: this.state.keyword,
      trangThai: this.state.trangThai,
      startDate: this.state.startDate.format('YYYYMMDD'),
      endDate: this.state.endDate.format('YYYYMMDD'),
      page: 0,
      per_page: 0
    }
    return lsnhapkhoExportXlsRequest(requestData, (listExp) => {
      var dataFile = new Blob([listExp], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExport';
      var fileName = "ds_nhap.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExport";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
      }
    });
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  componentDidMount() {
    this.fetchListNhaCC();
    this.fetchListKho();
    this.fetchList();
  }
  sum = (items, prop) => {
    return items.reduce(function (a, b) {
      return a + b[prop];
    }, 0);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.lsnhapkho.type == lsnhapkhoConstant.LSNHAPKHO_LIST_NCC_SUCCESS) {
      let { listNcc } = nextProps.lsnhapkho;
      this.setState({
        listNcc: this.buildSelectOptionNcc(listNcc)
      });
    }
    else if (nextProps.lsnhapkho.type == lsnhapkhoConstant.LSNHAPKHO_LIST_KHO_SUCCESS) {
      let { listKho } = nextProps.lsnhapkho;
      this.setState({
        listKho: this.buildSelectOptionKho(listKho)
      });
    }
    else if (nextProps.lsnhapkho.type == lsnhapkhoConstant.LSNHAPKHO_LIST_SUCCESS) {
      let { list, item } = nextProps.lsnhapkho;
      this.setState(
        {
          page: item.page,
          per_page: item.per_page,
          total_record: item.total_record,
          total_amountBefore: item.total_amount && item.total_amount[0].totalamountBefore || 0,
          total_amountAfter: item.total_amount && item.total_amount[0].totalamountAfter || 0,
          list: list
        }
      )
    }
    else if (nextProps.lsnhapkho.type == lsnhapkhoConstant.LSNHAPKHO_PRINT_SUCCESS) {
      let dataPrint = nextProps.lsnhapkho.item;
      var pdfFile = new Blob([dataPrint], {
        type: "application/pdf;charset=UTF-8"
      });
      var pdfUrl = URL.createObjectURL(pdfFile);
      printJS(pdfUrl);
    }
  }
  render() {
    const { list, selectedOptionNcc, selectedOptionKho } = this.state
    const {
      handleSubmit,
      lsnhapkho: {
        listRequesting,
      },
    } = this.props
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting}>
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row>
                <Col sm="4" xs="6" md="2" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <DatePicker name="startDate"
                      dateFormat="DD/MM/YYYY"
                      placeholderText="Từ ngày"
                      selected={this.state.startDate}
                      onChange={this.handleControlChange.bind(this, "startDate")}
                      required className={"form-control"} autoComplete="off" />
                  </InputGroup>
                </Col>
                <Col sm="4" xs="6" md="2" className="mb-1  pl-2 pr-2">
                  <InputGroup size="md">
                    <DatePicker name="endDate" dateFormat="DD/MM/YYYY" placeholderText="Đến ngày"
                      selected={this.state.endDate}
                      onChange={this.handleControlChange.bind(this, "endDate")}
                      required
                      className={"form-control"} autoComplete="off" />
                  </InputGroup>
                </Col>

                <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                  <Select
                    placeholder="Chọn nhà cung cấp"
                    value={selectedOptionNcc}
                    onChange={this.handleNccChange}
                    options={this.state.listNcc}
                  />
                </Col>
                <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                  <Select
                    placeholder="Chọn kho"
                    value={selectedOptionKho}
                    onChange={this.handleKhoChange}
                    options={this.state.listKho}
                  />
                </Col>
                <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <select className="form-control" value={this.state.trangThai} onChange={this.handleSelectChange.bind(this, "TrangThai")}>
                      <option value="">Trạng thái</option>
                      <option value={0}>Chưa duyệt</option>
                      <option value={1}>Đã duyệt</option>
                    </select>
                  </InputGroup>
                </Col>
                <Col sm="4" xs="12" md="4" className="mb-1 pl-2 pr-2">
                  <InputGroup size="md">
                    <InputGroupAddon addonType="prepend" autoComplete="off" >Số phiếu</InputGroupAddon>
                    <Input name="keyword" placeholder="Số phiếu"
                      value={this.state.keyword}
                      onChange={this.handleSearchChange.bind(this, "keyword")}
                      autoComplete="off"
                      onKeyDown={e => this.keyPress(e)} />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
          </div>
          <div className="mt-2 bg-white">
            <Button size="md" className="pull-left mr-1" color="success" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Tìm kiếm</Button>
            <div className="w-100 mb-2">
              <ButtonExt className="mr-1"
                color="primary"
                iconClass="fa-plus"
                displayText="Thêm mới"
                btnClick={() => this.addNhapClick({})}
                permission={BtnPermissions.NhapHang.ADD} />&nbsp;
              <Button size="md" color="success" className="mr-1 mb-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
            </div>
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="table-outline table-sm mb-0 d-sm-table table table-hover">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="30" className="text-center table-border-right">#</th>
                    <th scope="col" width="80" className="text-center table-border-right">Số phiếu</th>
                    <th scope="col" className="text-left table-border-right">Nhà cung cấp</th>
                    <th scope="col" width="100" className="text-right table-border-right">Tiền Vat</th>
                    <th scope="col" width="100" className="text-right table-border-right">Tiền Ck</th>
                    <th scope="col" width="110" className="text-right table-border-right">Tiền trước vat</th>
                    <th scope="col" width="110" className="text-right table-border-right">Tiền sau vat</th>
                    <th scope="col" width="100" className="text-center table-border-right">Người tạo</th>
                    <th scope="col" width="100" className="text-center table-border-right">Ngày tạo</th>
                    <th scope="col" width="100" className="text-center table-border-right">Trạng thái</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center table-border-right">{idx + 1}</td>
                        <td className="table-border-right">
                          <a href='#' onClick={this.editSoHd.bind(this, res.Id)}>{res.So}</a>
                        </td>
                        <td className="text-left table-border-right">{res.TenNhaCungCap}</td>
                        <td className="text-right text-dange table-border-right">{parseFloat(res.TongTienVat || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right text-danger table-border-right">{parseFloat(res.TongTienCK || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right text-danger table-border-right">{parseFloat(res.TongTienTruocVat || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right text-danger table-border-right">{parseFloat(res.TongTienSauVat || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right table-border-right">{res.TenNguoiNhap}</td>
                        <td className="text-center table-border-right">{res.NgayNhap && <Moment tz={'UTC'} format="HH:mm DD/MM">{`${res.NgayNhap}`}</Moment>}</td>
                        <td className="table-border-right">{res.TenTrangThai}</td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="10" className="text-right">
                      Tổng trước thuế:
                     <span className="text-success">
                        {this.state.total_amountBefore &&
                          this.state.total_amountBefore.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫</span>
                      - Tổng sau thuế:
                      <span className="text-success">
                        {this.state.total_amountAfter &&
                          this.state.total_amountAfter.toLocaleString("vi-VN",
                            { minimumFractionDigits: 0 })} ₫
                          </span>
                    </th>
                  </tr>
                </tfoot>
              </Table>
              {this.state.total_record > this.state.per_page && (
                <nav>
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={this.state.per_page}
                    totalItemsCount={this.state.total_record}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange}
                  />
                </nav>
              )}
            </div>
            <div className="clearfix"></div>
          </div>

        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  lsnhapkho: state.lsnhapkho,
  client: state.client,
})

const connected = connect(
  mapStateToProps, {
  lsnhapkhoListNhaCCRequest: lsnhapkhoAction.lsnhapkhoListNhaCCRequest,
  lsnhapkhoListKhoRequest: lsnhapkhoAction.lsnhapkhoListKhoRequest,
  lsnhapkhoListRequest: lsnhapkhoAction.lsnhapkhoListRequest,
  lsnhapkhoPrintRequest: lsnhapkhoAction.lsnhapkhoPrintRequest,
  lsnhapkhoExportXlsRequest: lsnhapkhoAction.lsnhapkhoExportXlsRequest
}
)(LsNhapKho)

const formed = reduxForm({
  form: 'lsnhapkho',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/LsNhapKho/LsNhapKho.js